export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAIAAADZSiLoAAAAF0lEQVR4nGNgYPjPwMDAwMDAxAADCBYAGz8BBKsKM64AAAAASUVORK5CYII="